import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Custom hook to detect RTL language direction
 * Returns true if the current language is RTL (Persian or Arabic)
 * @returns {boolean} isRTL - true if language is RTL, false otherwise
 */
export const useRTL = () => {
  const { i18n } = useTranslation();
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    const lang = i18n.language || localStorage.getItem("SiteLanguage") || "en";
    setIsRTL(
      lang === "fa" ||
        lang === "ar" ||
        document.querySelector("html")?.classList.contains("rtl-Lang")
    );
  }, [i18n.language]);

  return isRTL;
};
